module.exports = false;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0